/* eslint-disable react-hooks/exhaustive-deps */
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjcCore from "@grapecity/wijmo"
import * as wjrInput from "@grapecity/wijmo.react.input"

import dayjs from "dayjs"
import * as wjcInput from "@grapecity/wijmo.input"
import { useContext, useEffect, useState } from "react"
import { Table } from "react-bootstrap"
import { Button, Col, Container, Row } from "react-bootstrap"
import { useSelector, useDispatch } from "react-redux"
import { AppDispatch } from "../../../.."
import ComboBox from "../../../../components/ComboBox"
import { T区分マスタ } from "../../../../components/ComboBox/KubunComboBox"
import CheckInput from "../../../../components/InputWrapper/CheckInput"
import DateInput from "../../../../components/InputWrapper/DateInput"
import TextInput from "../../../../components/InputWrapper/TextInput"
import RequiredMark from "../../../../components/RequiredMark"
import CONSTANT from "../../../../constant"
import {
  TFile,
  TSyaryoBunrui,
  TSyaryoTokusyu,
} from "../../../../globalStore/pageStore/syaryoMaster/baseData"
import {
  syaryoMasterActions,
  TSyaryoMasterState,
} from "../../../../globalStore/pageStore/syaryoMaster/syaryoMasterStore"
import { RootState } from "../../../../globalStore/rootreducer"
import KubunService from "../../../../service/master/kubun/kubunService"
import {
  TWijmoCellTemplateContext,
  TWijmoComboBox,
} from "../../../../type/wijmoComponents"
// import FileUploadModal from "./AttachedFileModal"
// immutable
import {
  copyObject,
  DataChangeEventArgs,
} from "@grapecity/wijmo.grid.immutable"
//React/Redux
import { DataChangeAction } from "@grapecity/wijmo.grid.immutable"
import { ImmutabilityProvider } from "@grapecity/wijmo.react.grid.immutable"
import { T支払先 } from "../../../../components/ComboBox/SiharaiSakiComboBox"
import { e支払先区分 } from "../../../../constant/enum/master"
import SiharaisakiService from "../../../../service/master/siharaisaki/siharaisakiService"
import { T会社マスタ } from "../../../../components/ComboBox/KaisyaComboBox"
import KaisyaService from "../../../../service/master/kaisya/kaisyaService"
import FileUploadModal from "./AttachedFileModal"
import ConfirmModal from "../../../../components/Modal/ConfirmModal"
import commonUtil from "../../../../ts/util/commonUtil"
import { BlobContext } from "../SyaryoMasterRegisterContext"
import ContentService from "../../../../service/content/contentService"
import { setAlerts } from "../../../../globalStore/alertStore"
import saveAs from "file-saver"
import dateUtil from "../../../../ts/util/dateUtil"

/**
 * 車輌マスタ登録 基本データ部
 * @returns
 */
const MainDataPane: React.FC<{
  isLoadEnded: boolean
  setIsLoadEnded: React.Dispatch<React.SetStateAction<boolean>>
}> = (props) => {
  //#region [selector]
  const syaryoMaster: TSyaryoMasterState = useSelector(
    (state: RootState) => state.page.syaryoMaster
  )
  const disPatch: AppDispatch = useDispatch()
  const { addBlobItem, removeBlobItem } = useContext(BlobContext)

  //#endregion

  //#region [state]
  const [, set陸運支局報告分類区分] = useState<T区分マスタ | null>(null)
  const [, set車輌営業所区分] = useState<T区分マスタ | null>(null)
  // 和暦
  const [車検満了日_和暦, set車検満了日_和暦] = useState<string>()
  const [有効期限_和暦, set有効期限_和暦] = useState<string>()
  const [isShowAttachedFileModal, setIsShowAttachedFileModal] = useState(false)

  const [selected添付ファイル, setSelected添付ファイル] = useState<TFile>()
  const [isShowDeleteFileConfirmModal, setIsShowDeleteFileConfirmModal] =
    useState(false)

  // ComboBoxデータ読込フラグ
  const [comboDataInitialized, setComboDataInitialized] = useState(false)

  //#endregion

  //#region [comboboxState]
  // 区分ItemsSource
  const [区分ItemSource, set区分ItemSource] = useState<T区分マスタ[]>()

  // 陸運支局報告分類区分ComboBox
  const [陸運支局報告分類区分ComboBox, set陸運支局報告分類区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [陸運支局報告分類区分isLoadEnded, set陸運支局報告分類区分isLoadEnded] =
    useState<boolean>(false)

  // メーカー車名ComboBox
  const [メーカー車名ComboBox, setメーカー車名ComboBox] =
    useState<TWijmoComboBox<string, T支払先> | null>(null)
  const [メーカー車名isLoadEnded, setメーカー車名isLoadEnded] =
    useState<boolean>(false)
  const [支払先ItemSource, set支払先ItemSource] = useState<T支払先[]>()

  // 使用者名称ComboBox
  const [使用者名称ComboBox, set使用者名称ComboBox] = useState<TWijmoComboBox<
    string,
    T会社マスタ
  > | null>(null)
  const [使用者名称ItemSource, set使用者名称ItemSource] =
    useState<T会社マスタ[]>()
  const [使用者名称isLoadEnded, set使用者名称isLoadEnded] =
    useState<boolean>(false)

  // 車輌営業所区分ComboBox
  const [車輌営業所区分ComboBox, set車輌営業所区分ComboBox] =
    useState<TWijmoComboBox<string, T区分マスタ> | null>(null)
  const [車輌営業所区分isLoadEnded, set車輌営業所区分isLoadEnded] =
    useState<boolean>(false)

  //#endregion

  //#region [effect]
  useEffect(() => {
    Promise.all([
      new KubunService().getList(),
      new SiharaisakiService().getList({
        支払先区分コード: e支払先区分.メーカー,
      }),
      new KaisyaService().getList(),
    ]).then(([区分マスタRes, メーカー車名マスタRes, 会社Res]) => {
      区分マスタRes && set区分ItemSource(区分マスタRes.data)
      set支払先ItemSource(メーカー車名マスタRes.data)
      setComboDataInitialized(true)
      set使用者名称ItemSource(会社Res.data)
    })
  }, [])

  // component読込監視してフラグを親画面へ返却
  useEffect(() => {
    if (
      comboDataInitialized &&
      陸運支局報告分類区分ComboBox &&
      メーカー車名ComboBox &&
      使用者名称ComboBox
    ) {
      props.setIsLoadEnded(true)
    }
  }, [
    comboDataInitialized,
    陸運支局報告分類区分ComboBox,
    メーカー車名ComboBox,
    使用者名称ComboBox,
  ])

  //#endregion

  //#region [method]
  /**
   * 車輌分類グリッド編集イベント
   * @param s grid
   * @param e
   */
  const onBunruiGridDataChanged = (
    s: wjrGrid.FlexGrid,
    e: DataChangeEventArgs
  ) => {
    const bunruiItem = e.newItem as TSyaryoBunrui
    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          syaryoMasterActions.add車輌分類テーブル({ newItem: bunruiItem })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          syaryoMasterActions.remove車輌分類テーブル({
            rowId: bunruiItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          syaryoMasterActions.set車輌分類テーブルRow({
            // row_id: e.itemIndex,
            newItem: bunruiItem,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  /**
   * 車輌特種グリッド編集イベント
   * @param s grid
   * @param e
   */
  const onTokusyuGridDataChanged = (
    s: wjrGrid.FlexGrid,
    e: DataChangeEventArgs
  ) => {
    const tokusyuItem = e.newItem as TSyaryoTokusyu
    switch (e.action) {
      case DataChangeAction.Add:
        disPatch(
          syaryoMasterActions.add車輌特種テーブル({ newItem: tokusyuItem })
        )
        break
      case DataChangeAction.Remove:
        disPatch(
          syaryoMasterActions.remove車輌特種テーブル({
            rowId: tokusyuItem.row_id!,
          })
        )
        break
      case DataChangeAction.Change:
        disPatch(
          syaryoMasterActions.set車輌特種テーブルRow({
            // row_id: e.itemIndex,
            newItem: tokusyuItem,
          })
        )

        break
      default:
        console.log("例外")
    }
  }

  //TODO:色変えイベント
  // gridの必須チェックおよび検索イベント
  const bunruiFormatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        // let isExistData = true
        const rowData: TSyaryoBunrui = e.getRow().dataItem
        // const cellBinding = e.getColumn().binding

        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = rowData.削除フラグ === 1
        wjcCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)

        // エラーセルの色変え
        // if (
        //   errorCellPositionList.find(
        //     (e) => e.colBinding === cellBinding && e.行ID === rowData.行ID
        //   )
        // ) {
        //   isExistData = false
        // }
        // wjcCore.toggleClass(e.cell, "data-warning", !isExistData)
      }
    }
  }

  //TODO:色変えイベント
  // gridの必須チェックおよび検索イベント
  const tokusyuFormatItemHandler = (
    f: wjGrid.FlexGrid,
    e: wjGrid.FormatItemEventArgs
  ) => {
    if (e.panel === f.cells) {
      if (e.getColumn().binding !== null && e.getRow().dataIndex !== -1) {
        // let isExistData = true
        const rowData: TSyaryoTokusyu = e.getRow().dataItem
        // const cellBinding = e.getColumn().binding

        // 削除フラグ
        const row = e.getRow()
        row.isReadOnly = rowData.削除フラグ === 1
        wjcCore.toggleClass(e.cell, "read-only-cell", rowData.削除フラグ === 1)

        // エラーセルの色変え
        // if (
        //   errorCellPositionList.find(
        //     (e) => e.colBinding === cellBinding && e.行ID === rowData.行ID
        //   )
        // ) {
        //   isExistData = false
        // }
        // wjcCore.toggleClass(e.cell, "data-warning", !isExistData)
      }
    }
  }

  const add添付ファイル = async (
    file: File | undefined,
    fileUrl: string,
    comment: string
  ) => {
    if (selected添付ファイル != null) {
      const updateItem = {
        ...selected添付ファイル,
        コメント: comment,
      }
      disPatch(syaryoMasterActions.edit添付ファイル(updateItem))
      setSelected添付ファイル(updateItem)
    } else {
      if (file != null) {
        const newFile: TFile = {
          row_id: commonUtil.getUniqueStr(),
          ファイルURL: fileUrl,
          ファイル名: file.name,
          アップロード日時: "",
          コメント: comment,
          更新日時: "",
          削除フラグ: 0,
        }
        disPatch(syaryoMasterActions.add添付ファイル(newFile))

        // Fileをコンテキスト経由で保持
        addBlobItem({ id: newFile.row_id!, blob: file, imageUrl: "" })
      }
    }
    setIsShowAttachedFileModal(false)
  }

  const remove添付ファイル = (fileData: TFile) => {
    if (fileData.車輌添付ID == null) {
      // store連動
      disPatch(syaryoMasterActions.remove添付ファイル(fileData))

      // コンテキスト連動
      removeBlobItem(fileData.row_id!)
    } else {
      // 既存データの場合は削除フラグ更新
      disPatch(
        syaryoMasterActions.edit添付ファイル({ ...fileData, 削除フラグ: 1 })
      )
    }

    setSelected添付ファイル(undefined)
    setIsShowAttachedFileModal(false)
  }

  //#endregion
  return (
    <>
      <div className="accordion-header">
        車検証
        <div className="accordion-description">
          車検証・基準緩和・架装情報・車輌分類・車輌特種・添付ファイル
        </div>
      </div>
      <div>
        <div>
          <h5>車検証</h5>
          <Container className="register-form" fluid>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-10rem">
                        陸運支局報告分類
                        <RequiredMark />
                      </th>
                      <td>
                        <div className="input-group">
                          <ComboBox.Kubun
                            分類コード="C0002"
                            isLoadEnded={陸運支局報告分類区分isLoadEnded}
                            setIsLoadEnded={set陸運支局報告分類区分isLoadEnded}
                            isAllSelect={false}
                            isRequired={true}
                            itemsSource={区分ItemSource}
                            selectedValue={
                              syaryoMaster.陸運支局報告分類区分コード
                            }
                            setSelectedValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set陸運支局報告分類区分コード(
                                  v ?? undefined
                                )
                              )
                            }
                            setSelectedItem={set陸運支局報告分類区分}
                            ComboBox={陸運支局報告分類区分ComboBox}
                            setComboBox={
                              set陸運支局報告分類区分ComboBox
                            }></ComboBox.Kubun>
                        </div>
                      </td>
                      <th className="min-w-8rem">車体形状(車種)</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="車体形状"
                            name="車体形状"
                            value={syaryoMaster.車体形状}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set車体形状(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">車種詳細</th>
                      <td colSpan={5}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "30rem" }}
                            id="車種詳細"
                            name="車種詳細"
                            value={syaryoMaster.車種詳細}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set車種詳細(v))
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">メーカー車名</th>
                      <td>
                        <div className="input-group">
                          {" "}
                          <ComboBox.SiharaiSaki
                            siharaiSaki={e支払先区分.メーカー}
                            isLoadEnded={メーカー車名isLoadEnded}
                            setIsLoadEnded={setメーカー車名isLoadEnded}
                            isRequired={false}
                            isEmpty={true}
                            itemsSource={支払先ItemSource}
                            selectedValue={syaryoMaster.メーカーコード}
                            setSelectedValue={(v) => {
                              disPatch(syaryoMasterActions.setメーカーコード(v))
                            }}
                            ComboBox={メーカー車名ComboBox}
                            setComboBox={
                              setメーカー車名ComboBox
                            }></ComboBox.SiharaiSaki>
                        </div>
                      </td>
                      <th className="min-w-8rem">最大積載量(kg)</th>
                      <td>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="最大積載量"
                            name="最大積載量"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.最大積載量}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(
                                    syaryoMasterActions.set最大積載量(c.value)
                                  )
                                : disPatch(
                                    syaryoMasterActions.set最大積載量(undefined)
                                  )
                            }}
                          />
                        </div>
                      </td>
                      {/* <th className="min-w-8rem">最大積載量2(kg)</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "10rem", textAlign: "right" }}
                            id="最大積載量2"
                            name="最大積載量2"
                            isRequired={false}
                            value={syaryoMaster.最大積載量2}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set最大積載量2(v))
                            }
                          />
                        </div>
                      </td> */}
                      <th className="min-w-8rem">車輌重量(kg)</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "10rem", textAlign: "right" }}
                            id="車輌重量"
                            name="車輌重量"
                            isRequired={false}
                            value={syaryoMaster.車輌重量}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set車輌重量(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">車輌総重量(kg)</th>
                      <td colSpan={3}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "10rem", textAlign: "right" }}
                            id="車輌総重量"
                            name="車輌総重量"
                            isRequired={false}
                            value={syaryoMaster.車輌総重量}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set車輌総重量(v))
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">車台番号</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="車台番号"
                            name="車台番号"
                            value={syaryoMaster.車台番号}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set車台番号(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">長さ(cm)</th>
                      <td>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="長さ"
                            name="長さ"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.長さ}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(syaryoMasterActions.set長さ(c.value))
                                : disPatch(
                                    syaryoMasterActions.set長さ(undefined)
                                  )
                            }}
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">幅(cm)</th>
                      <td>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="幅"
                            name="幅"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.幅}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(syaryoMasterActions.set幅(c.value))
                                : disPatch(syaryoMasterActions.set幅(undefined))
                            }}
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">高さ(cm)</th>
                      <td colSpan={3}>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="高さ"
                            name="高さ"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.高さ}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(syaryoMasterActions.set高さ(c.value))
                                : disPatch(
                                    syaryoMasterActions.set高さ(undefined)
                                  )
                            }}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">シリアルNO</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="シリアルNo"
                            name="シリアルNo"
                            value={syaryoMaster.シリアルNo}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.setシリアルNo(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">前前軸重(kg)</th>
                      <td>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="前前軸重"
                            name="前前軸重"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.前前軸重}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(
                                    syaryoMasterActions.set前前軸重(c.value)
                                  )
                                : disPatch(
                                    syaryoMasterActions.set前前軸重(undefined)
                                  )
                            }}
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">前後軸重(kg)</th>
                      <td>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="前後軸重"
                            name="前後軸重"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.前後軸重}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(
                                    syaryoMasterActions.set前後軸重(c.value)
                                  )
                                : disPatch(
                                    syaryoMasterActions.set前後軸重(undefined)
                                  )
                            }}
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">後前軸重(kg)</th>
                      <td>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="後前軸重"
                            name="後前軸重"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.後前軸重}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(
                                    syaryoMasterActions.set後前軸重(c.value)
                                  )
                                : disPatch(
                                    syaryoMasterActions.set後前軸重(undefined)
                                  )
                            }}
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">後後軸重(kg)</th>
                      <td>
                        <div className="input-group">
                          <wjrInput.InputNumber
                            style={{ width: "10rem", textAlign: "right" }}
                            id="後後軸重"
                            name="後後軸重"
                            format={"N0"}
                            isRequired={false}
                            value={syaryoMaster.後後軸重}
                            valueChanged={(c: wjcInput.InputNumber, e: any) => {
                              c.value != null
                                ? disPatch(
                                    syaryoMasterActions.set後後軸重(c.value)
                                  )
                                : disPatch(
                                    syaryoMasterActions.set後後軸重(undefined)
                                  )
                            }}
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">型式</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="型式"
                            name="型式"
                            value={syaryoMaster.車輌形式}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set車輌形式(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">原動機の型式</th>
                      <td colSpan={7}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="原動機の型式"
                            name="原動機の型式"
                            value={syaryoMaster.原動機型式}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set原動機型式(v))
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">所有者名称</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="所有者名称"
                            name="所有者名称"
                            value={syaryoMaster.所有者名称}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set所有者名称(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">車検満了日</th>
                      <td>
                        <div className="input-group">
                          <div className="w-10rem">
                            <DateInput
                              id="車検満了日"
                              value={syaryoMaster.車検満了日}
                              setValue={(v) => {
                                disPatch(
                                  syaryoMasterActions.set車検満了日(
                                    v ?? undefined
                                  )
                                )
                                // 和暦変換
                                if (v == null) return
                                set車検満了日_和暦(dayjs(v).format("rrrr"))
                              }}></DateInput>
                          </div>
                          <TextInput
                            style={{ width: "7rem" }}
                            id="車検満了日_和暦"
                            name="車検満了日_和暦"
                            maxLength={5}
                            isReadOnly
                            value={車検満了日_和暦}
                            setValue={(v) => {}}></TextInput>
                        </div>
                      </td>
                      <th className="min-w-8rem">使用者名称</th>
                      <td colSpan={2}>
                        <div className="input-group min-w-10rem">
                          <ComboBox.Kaisya
                            isAllSelect={false}
                            isEmpty={true}
                            itemsSource={使用者名称ItemSource}
                            isLoadEnded={使用者名称isLoadEnded}
                            setIsLoadEnded={set使用者名称isLoadEnded}
                            selectedValue={syaryoMaster.使用者名称}
                            setSelectedValue={(v) => {
                              disPatch(
                                syaryoMasterActions.set使用者名称(
                                  v ?? undefined
                                )
                              )
                            }}
                            ComboBox={使用者名称ComboBox}
                            setComboBox={
                              set使用者名称ComboBox
                            }></ComboBox.Kaisya>
                        </div>
                      </td>
                      <th className="min-w-8rem">車輌営業所</th>
                      <td colSpan={2}>
                        <div className="input-group min-w-8rem">
                          <ComboBox.Kubun
                            分類コード="C0009"
                            isLoadEnded={車輌営業所区分isLoadEnded}
                            setIsLoadEnded={set車輌営業所区分isLoadEnded}
                            isAllSelect={false}
                            isRequired={false}
                            itemsSource={区分ItemSource}
                            selectedValue={syaryoMaster.車輌営業所}
                            setSelectedValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set車輌営業所(
                                  v ?? undefined
                                )
                              )
                            }
                            setSelectedItem={set車輌営業所区分}
                            ComboBox={車輌営業所区分ComboBox}
                            setComboBox={
                              set車輌営業所区分ComboBox
                            }></ComboBox.Kubun>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        </div>
        <div>
          <h5>基準緩和</h5>
          <Container className="register-form" fluid>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-10rem">基準緩和車輌</th>
                      <td>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="基準緩和車輌"
                            name="基準緩和車輌"
                            value={syaryoMaster.基準緩和車輌}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set基準緩和車輌(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">有効期限</th>
                      <td>
                        <div className="input-group">
                          <DateInput
                            id="有効期限"
                            value={syaryoMaster.基準緩和有効期限}
                            setValue={(v) => {
                              disPatch(
                                syaryoMasterActions.set基準緩和有効期限(
                                  v ?? undefined
                                )
                              )
                              // 和暦変換
                              if (v == null) return
                              set有効期限_和暦(dayjs(v).format("rrrr"))
                            }}></DateInput>
                          <TextInput
                            style={{ width: "7rem" }}
                            id="有効期限_和暦"
                            name="有効期限_和暦"
                            maxLength={5}
                            isReadOnly
                            value={有効期限_和暦}
                            setValue={(v) => {}}></TextInput>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">緩和書類制作会社</th>
                      <td colSpan={6}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "30rem" }}
                            id="緩和書類制作会社"
                            name="緩和書類制作会社"
                            value={syaryoMaster.緩和書類制作会社}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set緩和書類制作会社(v)
                              )
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">緩和輸送依頼荷主</th>
                      <td colSpan={6}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "30rem" }}
                            id=""
                            name="緩和輸送依頼荷主"
                            value={syaryoMaster.緩和輸送依頼荷主}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set緩和輸送依頼荷主(v)
                              )
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        </div>
        <div>
          <h5>架装情報</h5>
          <Container className="register-form" fluid>
            <Row>
              <Col>
                <Table className="form-table">
                  <tbody>
                    <tr>
                      <th className="min-w-10rem">架装メーカー</th>
                      <td colSpan={2}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "20rem" }}
                            id="架装メーカー"
                            name="架装メーカー"
                            value={syaryoMaster.架装メーカー}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set架装メーカー(v))
                            }
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">架装タンクNo</th>
                      <td colSpan={2}>
                        <div className="input-group">
                          <TextInput
                            id="架装タンクNo"
                            name="架装タンクNo"
                            value={syaryoMaster.架装タンクNO}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set架装タンクNo(v))
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">台帳保管ファイル名</th>
                      <td colSpan={6}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "40rem" }}
                            id="台帳保管ファイル名"
                            name="台帳保管ファイル名"
                            value={syaryoMaster.台帳保管ファイル名}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set台帳保管ファイル名(v)
                              )
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">備考1</th>
                      <td colSpan={6}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "40rem" }}
                            id="架装情報備考1"
                            name="架装情報備考1"
                            value={syaryoMaster.備考１}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set架装情報備考1(v))
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">備考2</th>
                      <td colSpan={6}>
                        <div>
                          <TextInput
                            style={{ width: "40rem" }}
                            id="架装情報備考2"
                            name="架装情報備考2"
                            value={syaryoMaster.備考２}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set架装情報備考2(v))
                            }
                          />
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <th className="min-w-8rem">任意保険</th>
                      <td colSpan={1}>
                        <div className="input-group">
                          <div className="w-8rem">
                            <CheckInput
                              id="任意保険"
                              type={"switch"}
                              label={""}
                              setValue={(v) =>
                                disPatch(
                                  syaryoMasterActions.set任意保険加入フラグ(v)
                                )
                              }
                              value={syaryoMaster.任意保険加入フラグ ?? 0}
                            />
                          </div>
                        </div>
                      </td>
                      <th className="min-w-8rem">火暴露</th>
                      <td colSpan={1}>
                        <div className="input-group">
                          <CheckInput
                            id="火暴露"
                            type={"switch"}
                            label={""}
                            setValue={(v) =>
                              disPatch(
                                syaryoMasterActions.set火炎暴露保険フラグ(v)
                              )
                            }
                            value={syaryoMaster.火炎暴露保険フラグ ?? 0}
                          />
                        </div>
                      </td>
                      <th className="min-w-8rem">保険No</th>
                      <td colSpan={1}>
                        <div className="input-group">
                          <TextInput
                            style={{ width: "max-content" }}
                            id="保険No"
                            name="保険No"
                            value={syaryoMaster.保険NO}
                            setValue={(v) =>
                              disPatch(syaryoMasterActions.set保険No(v))
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </Container>
        </div>
        <div>
          <Row>
            <Col xs={6}>
              <h5>車輌分類</h5>
              <div>
                <div>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    // width={"600px"}
                    formatItem={bunruiFormatItemHandler}>
                    <ImmutabilityProvider
                      itemsSource={syaryoMaster.車輌分類}
                      dataChanged={onBunruiGridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="分類１"
                      width={"*"}
                      header="分類1"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="分類２"
                      width={300}
                      header="分類2"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="Row_id"
                      width={60}
                      isReadOnly={true}
                      header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TSyaryoBunrui>
                        ) => {
                          // Store反映前に削除ボタン使えないため、row_idの有無も制御に加える
                          if (!context.item.row_id) return
                          return context.item.削除フラグ !== 1 ? (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={"waiting"}
                              onClick={(e) => {
                                e.preventDefault()
                                // 削除処理
                                if (context.item.車輌分類ID) {
                                  // 削除フラグを設定する。
                                  // 対象データ行の削除フラグを変更して変数へコピーする
                                  let rowItem = Object.freeze(
                                    copyObject(
                                      {},
                                      { ...context.item, 削除フラグ: 1 }
                                    )
                                  )

                                  // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                                  disPatch(
                                    syaryoMasterActions.set車輌分類テーブルRow({
                                      // row_id: context.item.row_id!,
                                      newItem: rowItem,
                                    })
                                  )
                                } else {
                                  // PKない場合、Storeから対象データ行をRemoveする。
                                  disPatch(
                                    syaryoMasterActions.remove車輌分類テーブル({
                                      rowId: context.item.row_id!,
                                    })
                                  )
                                }
                              }}>
                              削除
                            </Button>
                          ) : (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={"pending"}
                              onClick={(e) => {
                                e.preventDefault()
                                // 削除フラグを解除する
                                // 対象データ行の削除フラグを変更して変数へコピーする
                                let rowItem = Object.freeze(
                                  copyObject(
                                    {},
                                    { ...context.item, 削除フラグ: 0 }
                                  )
                                )

                                // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                                disPatch(
                                  syaryoMasterActions.set車輌分類テーブルRow({
                                    // row_id: context.item.row_id!,
                                    newItem: rowItem,
                                  })
                                )
                              }}>
                              解除
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </div>
              </div>
            </Col>
            <Col xs={6}>
              <h5>車輌特種</h5>
              <div>
                <div>
                  <wjrGrid.FlexGrid
                    {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS_EDIT}
                    formatItem={tokusyuFormatItemHandler}>
                    <ImmutabilityProvider
                      itemsSource={syaryoMaster.車輌特種}
                      dataChanged={onTokusyuGridDataChanged}
                    />
                    <wjrGrid.FlexGridColumn
                      binding="分類１"
                      width={"*"}
                      header="分類1"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="分類２"
                      width={300}
                      header="分類2"></wjrGrid.FlexGridColumn>
                    <wjrGrid.FlexGridColumn
                      binding="Row_id"
                      width={60}
                      isReadOnly={true}
                      header=" ">
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TSyaryoTokusyu>
                        ) => {
                          // Store反映前に削除ボタン使えないため、row_idの有無も制御に加える
                          if (!context.item.row_id) return
                          return context.item.削除フラグ !== 1 ? (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={"waiting"}
                              onClick={(e) => {
                                e.preventDefault()
                                // 削除処理
                                if (context.item.車輌特種ID) {
                                  // 削除フラグを設定する。
                                  // 対象データ行の削除フラグを変更して変数へコピーする
                                  let rowItem = Object.freeze(
                                    copyObject(
                                      {},
                                      { ...context.item, 削除フラグ: 1 }
                                    )
                                  )

                                  // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                                  disPatch(
                                    syaryoMasterActions.set車輌特種テーブルRow({
                                      // row_id: context.item.row_id!,
                                      newItem: rowItem,
                                    })
                                  )
                                } else {
                                  // PKない場合、Storeから対象データ行をRemoveする。
                                  disPatch(
                                    syaryoMasterActions.remove車輌特種テーブル({
                                      rowId: context.item.row_id!,
                                    })
                                  )
                                }
                              }}>
                              削除
                            </Button>
                          ) : (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant={"pending"}
                              onClick={(e) => {
                                e.preventDefault()
                                // 削除フラグを解除する
                                // 対象データ行の削除フラグを変更して変数へコピーする
                                let rowItem = Object.freeze(
                                  copyObject(
                                    {},
                                    { ...context.item, 削除フラグ: 0 }
                                  )
                                )

                                // 編集コピーした行データと編集行のrow_idを引数に渡してStore側で更新を行う。
                                disPatch(
                                  syaryoMasterActions.set車輌特種テーブルRow({
                                    // row_id: context.item.row_id!,
                                    newItem: rowItem,
                                  })
                                )
                              }}>
                              解除
                            </Button>
                          )
                        }}></wjrGrid.FlexGridCellTemplate>
                    </wjrGrid.FlexGridColumn>
                  </wjrGrid.FlexGrid>
                </div>
              </div>
            </Col>
          </Row>
        </div>
        <div>
          <h5>添付ファイル</h5>
          <div>
            <div>
              <div>
                <Button
                  className="m-2"
                  onClick={() => {
                    setSelected添付ファイル(undefined)
                    setIsShowAttachedFileModal(true)
                  }}>
                  追加
                </Button>
              </div>
              <wjrGrid.FlexGrid
                {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                itemsSource={syaryoMaster.添付ファイルリスト.filter(
                  (item) => item.削除フラグ === 0
                )}>
                <wjrGrid.FlexGridColumn
                  binding="Row_id"
                  width={150}
                  isReadOnly={true}
                  header=" ">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<TFile>) => {
                      return (
                        <>
                          <Button
                            className="btn btn-small btn-primary move-edit-page"
                            variant={"working"}
                            onClick={() => {
                              setSelected添付ファイル(context.item)
                              setIsShowAttachedFileModal(true)
                            }}>
                            編集
                          </Button>
                          <Button
                            className="btn btn-small btn-primary move-edit-page m-2"
                            variant={"waiting"}
                            onClick={() => {
                              setSelected添付ファイル(context.item)
                              setIsShowDeleteFileConfirmModal(true)
                            }}>
                            削除
                          </Button>
                        </>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ファイル名"
                  width={800}
                  header="ファイル">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<TFile>) => {
                      return (
                        <a
                          href={context.item.ファイルURL}
                          target="_blank"
                          rel="noopener noreferrer"
                          onClick={(e) => {
                            if (context.item.車輌添付ID != null) {
                              e.preventDefault()
                              const service = new ContentService()
                              service
                                .get(context.item.ファイルURL!)
                                .then((blob) => {
                                  saveAs(blob, context.item.ファイル名)
                                })
                                .catch((err) => disPatch(setAlerts(err)))
                            }
                          }}>
                          {context.item.ファイル名}
                        </a>
                      )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="コメント"
                  width={300}
                  header="コメント"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="アップロード日時"
                  width={300}
                  header="アップロード日時">
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(context: TWijmoCellTemplateContext<TFile>) => {
                      if ((context.item.アップロード日時 ?? "") !== "")
                        return dateUtil.format(
                          context.item.アップロード日時,
                          "YYYY/MM/DD HH:mm:ss"
                        )
                    }}></wjrGrid.FlexGridCellTemplate>
                </wjrGrid.FlexGridColumn>
              </wjrGrid.FlexGrid>
            </div>
          </div>
        </div>
      </div>

      {/* 添付ファイル用モーダル */}
      <FileUploadModal
        isShow={isShowAttachedFileModal}
        setIsShow={setIsShowAttachedFileModal}
        addItem={add添付ファイル}
        fileData={selected添付ファイル}
        isShowFileImage={false}
        fileImageUrl=""
        title="添付ファイル"></FileUploadModal>

      <ConfirmModal
        isShow={isShowDeleteFileConfirmModal}
        submitHandler={() => {
          remove添付ファイル(selected添付ファイル!)
          setIsShowDeleteFileConfirmModal(false)
        }}
        hideHandler={(isCancel) => {
          setIsShowDeleteFileConfirmModal(false)
        }}>
        <p>選択された添付ファイルを削除しますか？</p>
        <p>※実際の削除は登録ボタン押下時となります</p>
      </ConfirmModal>
    </>
  )
}

export default MainDataPane
